import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITestimonial, ITestimonialInitialState } from "./testimonialModel";
import {
  ActiveInactiveTestimonial,
  createTestimonial,
  deleteTestimonial,
  getAllActiveTestimonial,
  getAllTestimonial,
  getTestimonialByID,
  TestimonialImageUpload,
  updateTestimonial,
} from "./services/testimonial.services";

const initialState: ITestimonialInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  TestimonialID: null,
  TestimonialList: [],
  TestimonialDetail: {
    ID: null,
    CustomerName: "",
    TestimonialImage: "",
    Description: "",
    IsActive: 1,
  },
};

const testimonialSlice = createSlice({
  name: "testimonial",
  initialState,
  reducers: {
    clearTestimonialDetails: (state) => {
      state.TestimonialDetail = initialState.TestimonialDetail;
    },
    setTestimonialID: (state, action) => {
      state.TestimonialID = action.payload;
    },
    clearTestimonialID: (state) => {
      state.TestimonialID = initialState.TestimonialID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllTestimonial.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllTestimonial.fulfilled,
      (state, action: PayloadAction<ITestimonial[]>) => {
        state.loading = false;
        state.TestimonialList = action.payload || [];
      }
    );
    builder.addCase(getAllTestimonial.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.TestimonialList = [];
    });
    builder.addCase(createTestimonial.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createTestimonial.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createTestimonial.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateTestimonial.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateTestimonial.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateTestimonial.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteTestimonial.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteTestimonial.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteTestimonial.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getTestimonialByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getTestimonialByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.TestimonialDetail = action.payload;
    });
    builder.addCase(getTestimonialByID.rejected, (state, action) => {
      state.formLoading = false;
      state.TestimonialDetail = initialState.TestimonialDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveTestimonial.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveTestimonial.fulfilled,
      (state, action: PayloadAction<ITestimonial[]>) => {
        state.loading = false;
        state.TestimonialList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveTestimonial.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.TestimonialList = [];
    });
    builder.addCase(ActiveInactiveTestimonial.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveTestimonial.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveTestimonial.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(TestimonialImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(TestimonialImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(TestimonialImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearTestimonialDetails, clearTestimonialID, setTestimonialID } =
  testimonialSlice.actions;
export default testimonialSlice.reducer;
